import PropTypes from "prop-types"

import fetchBoxDesigns from "areas/product/hoc/fetch-box-designs"
import BoxDesign from "areas/product/jewlr/box-design"
import Modal from "components/modal"

const BoxDesignModal = ({ afterShow, boxDesigns, designBoxTitle }) => (
  <Modal
    afterShow={afterShow}
    contentClassName="flex"
    label={designBoxTitle}
    show="#box-design"
    width="750px"
  >
    <div className="flex w-full flex-col text-center">
      {boxDesigns.length > 0 && <BoxDesign pref="box" />}
    </div>
  </Modal>
)

BoxDesignModal.propTypes = {
  afterShow: PropTypes.func,
  boxDesigns: PropTypes.array,
  designBoxTitle: PropTypes.string,
}

export default fetchBoxDesigns(BoxDesignModal)
